import PropTypes from "prop-types";
import React from "react";
import _ from "lodash";
import isEqual from "lodash.isequal";
import classNames from "classnames";
import { TickerPlayer } from "signoxe/components";
import {
  checkLayoutInBounds,
  checkLayoutFilled,
} from "signoxe/utils/validateChannelLayout";
import RGL from "react-grid-layout";
import "./styles.scss";
import SelectSearch from "../SelectSearch";

const ReactGridLayout = RGL.WidthProvider(RGL);
import { API_ROOT } from "signoxe/constants/config";
class ChannelLayoutEditor extends React.Component {
  static propTypes = {
    regions: PropTypes.array.isRequired,
    playlists: PropTypes.array,
    tickers: PropTypes.array,
    editRegionsMode: PropTypes.bool,
    reportActivityStatus: PropTypes.bool,
    layoutWidth: PropTypes.number.isRequired,
    layoutHeight: PropTypes.number.isRequired,
    rows: PropTypes.number,
    cols: PropTypes.number,
    onRegionsChange: PropTypes.func,
    onRef: PropTypes.func,
    profile: PropTypes.object,
  };

  // static defaultProps = {
  //   rows: 12,
  //   cols: 12,
  // };

  constructor(props) {
    super(props);

    this.state = {
      layout: null,
      layoutIsValid: null,
      layoutIsFilled: null,
      layoutIsInBounds: null,
      regions: [],
      tickerIndex: 0,
      count: 0,
    };

    this.nextTicker = this.nextTicker.bind(this);
  }

  fromPropsToState(nextProps) {
    if (_.isEmpty(nextProps.regions) && !_.isEmpty(this.state.regions)) {
      this.setState({ regions: [] });
    } else {
      if (!_.isEmpty(nextProps.regions) && _.isEmpty(this.state.regions)) {
        this.setState({ regions: nextProps.regions });
      } else if (
        nextProps.regions &&
        !isEqual(nextProps.regions, this.props.regions)
      ) {
        this.setState({ regions: nextProps.regions });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.fromPropsToState(nextProps);

    const { regions } = this.state;
    let count = 0;

    const { playlists } = nextProps;

    regions.forEach((region, index) => {
      const playlist = playlists.find((e) => e.id === region.playlist);

      if (
        region.playlist != null &&
        playlist &&
        this.isVideoList(playlist.items)
      )
        count++;
    });
    this.setState({ count });
  }

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
    this.fromPropsToState(this.props);
  }

  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined);
  }

  addRegion = () => {
    const {rows, cols} = this.props
    let occupiedTiles = [];
    for (let i = 0; i < rows; ++i) {
      occupiedTiles[i] = [];
      for (let j = 0; j < cols; ++j) {
        occupiedTiles[i][j] = false;
      }
    }
    this.state.regions.forEach((region) => {
      for (
        let i = region.data_grid.x;
        i < region.data_grid.x + region.data_grid.w;
        ++i
      ) {
        for (
          let j = region.data_grid.y;
          j < region.data_grid.y + region.data_grid.h;
          ++j
        ) {
          occupiedTiles[i][j] = true;
        }
      }
    });
    let x = -1,
      y = -1;
    for (let i = 0; i < rows; ++i) {
      for (let j = 0; j < cols; ++j) {
        if (!occupiedTiles[i][j]) {
          x = i;
          y = j;
          break;
        }
      }
      if (x !== -1) {
        break;
      }
    }
    const lastId = _(this.state.regions)
      .map((region) => region.id)
      .max();

    if (this.props.rows > 46 || this.props.cols > 46) {
        this.setState(
          {
            regions: [
              ...this.state.regions,
              {
                id: lastId + 1,
                isPending: true,
                data_grid: { x: x, y: y, w: 4.5, h: 4.5 }, // w: 5, h: 5 for rows or cols > 46
                playlist: null,
              },
            ],
          },
          () => this.props.onRegionsChange(this.state.regions)
        );
      } else if (this.props.rows > 18 || this.props.cols > 18) {
        this.setState(
          {
            regions: [
              ...this.state.regions,
              {
                id: lastId + 1,
                isPending: true,
                data_grid: { x: x, y: y, w: 3, h: 3 }, // w: 3, h: 3 for rows or cols > 18
                playlist: null,
              },
            ],
          },
          () => this.props.onRegionsChange(this.state.regions)
        );
      } else {
        this.setState(
          {
            regions: [
              ...this.state.regions,
              {
                id: lastId + 1,
                isPending: true,
                data_grid: { x: x, y: y, w: 1.5, h: 1.5 }, // w: 1.5, h: 1.5 for rows or cols <= 18
                playlist: null,
              },
            ],
          },
          () => this.props.onRegionsChange(this.state.regions)
        );
      }
      
    // if(this.props.rows > 18 || this.props.cols > 18){
    //   this.setState(
    //     {
    //       regions: [
    //         ...this.state.regions,
    //         {
    //           id: lastId + 1,
    //           isPending: true,
    //           data_grid: { x: x, y: y, w: 3, h: 3 },
    //           playlist: null,
    //         },
    //       ],
    //     },
    //     () => this.props.onRegionsChange(this.state.regions)
    //   );
    // }

    // else{
    //   this.setState(
    //     {
    //       regions: [
    //         ...this.state.regions,
    //         {
    //           id: lastId + 1,
    //           isPending: true,
    //           data_grid: { x: x, y: y, w: 1.5, h: 1.5 },
    //           playlist: null,
    //         },
    //       ],
    //     },
    //     () => this.props.onRegionsChange(this.state.regions)
    //   );
    // }
  };

  onRemoveRegion(regionId) {
    this.setState(
      {
        regions: _.reject(this.state.regions, { id: regionId }),
      },
      () => this.props.onRegionsChange(this.state.regions)
    );
  }

  findOptionDisplayNameById(behaviours, id) {
    const option = behaviours.find(option => option.id === id);
    return option ? option.display_name : null;
  }
  onAssignPlaylist = (regionId, playlistId) => {
    console.log("regionID", regionId)
    // Find the index of the region in the state array
    const regionIndex = this.state.regions.findIndex(
      (region) => parseInt(region.id) === parseInt(regionId)
    );
  
    if (regionIndex === -1) {
      console.error(`Region with id ${regionId} not found.`);
      return;
    }
  
    const updatedRegions = [...this.state.regions]; // Create a copy of the regions array
  
    if (isNaN(playlistId)) {
      // If playlistId is not a number, set the playlist to null
      updatedRegions[regionIndex].playlist = null;
    } else {
      // Update the playlist for the specific region
      updatedRegions[regionIndex].playlist = parseInt(playlistId);
      const playlist = this.props.playlists.find((e) => e.id === updatedRegions[regionIndex].playlist);
  
      // Log activity if needed
      if (this.props.reportActivityStatus && this.props.handleUserReport) {
        this.props.handleUserReport(`Set Playlist (${playlist.name}) in Region NO (${regionId}) for `);
      }
    }
    console.log("updatedRegions", updatedRegions)
    // Update the state with the new array of regions
    this.setState(
      {
        regions: updatedRegions,
      },
      () => {
        // Callback after state is updated, if needed
        if (this.props.onRegionsChange) {
          this.props.onRegionsChange(this.state.regions);
        }
      }
    );
  };
  

  onAddBehaviour = (regionId, behaviour) => {
    const region = _.findLast(
      this.state.regions,
      (region) => parseInt(region.id) == parseInt(regionId)
    );
    if (isNaN(behaviour)) {
      region.behaviour = null;
    } else {
      region.behaviour = parseInt(behaviour);
    }
    this.setState(
      {
        regions: [...this.state.regions],
      },
      () => {
        if (this.props.onRegionsChange) {
          this.props.onRegionsChange(this.state.regions);
        }
      }
    );
  };

  onAddField = (field, regionId, value) => {
    const region = _.findLast(
      this.state.regions,
      (region) => parseInt(region.id) == parseInt(regionId)
    );
    region[field] = value;

    this.setRegionState(this.state.regions, this.props.onRegionsChange);
  };

  setRegionState = (regions, onRegionsChange) => {
    this.setState(
      {
        regions: [...regions],
      },
      () => {
        if (onRegionsChange) {
          onRegionsChange(regions);
        }
      }
    );
  };

  onAddFile = (field, regionId, file) => {
    // console.log("file", file)
    const region = _.findLast(
      this.state.regions,
      (region) => parseInt(region.id) == parseInt(regionId)
    );
    region[field] = file;
    this.setRegionState(this.state.regions, this.props.onRegionsChange);
  };  

  onLayoutChange(layout) {
    const regions = this.state.regions.map((region) => {
      region.data_grid = _.findLast(
        layout,
        (item) => parseInt(item.i) == parseInt(region.id)
      );
      return region;
    });

    const validators = {
      layoutIsFilled: checkLayoutFilled(
        this.props.rows,
        this.props.cols,
        layout
      ),
      layoutIsInBounds: checkLayoutInBounds(
        this.props.rows,
        this.props.cols,
        layout
      ),
    };
    validators.layoutIsValid =
      validators.layoutIsFilled && validators.layoutIsInBounds;

    this.setState({ regions, ...validators }, () => {
      if (this.props.onRegionsChange) {
        this.props.onRegionsChange(this.state.regions);
      }
    });
  }

  nextTicker(currentIndex, allowNextTicker) {
    return () => {
      if (!allowNextTicker) {
        return;
      }
      const nextIndex = currentIndex + 1;
      this.setState({
        tickerIndex: nextIndex % this.props.tickers.length,
      });
    };
  }

  getTicker() {
    if (this.props.tickers && this.props.tickers.length > 0) {
      return this.props.tickers[this.state.tickerIndex];
    } else return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  isVideoList = (items) => {
    let flag = false;
    for (let i = 0; i < items.length; i++) {
      if (items[i].item && items[i].item.type === "VIDEO") {
        flag = true;
        break;
      }
    }

    return flag;
  };

  getScrollerbehaviour(behaviours) {
    const ids = [];
    for (const data of behaviours) {
      if (["scroller", "touchscroller"].includes(data.name)) ids.push(data.id);
    }
    return ids;
  }

  getMirrorPublisher(behaviours) {
    for (const data of behaviours) {
      if (data.name === "mirror_publisher") return data.id;
    }
  }

  getDirectoryPublisher(behaviours) {
    for (const data of behaviours) {
      if (data.name === "directory_publisher") return data.id;
    }
  }

  getStandardbehaviour(behaviours) {
    for (const data of behaviours) {
      if (data.name === "standard") return data.id;
    }
  }
  isScroller(id, behaviours) {
    const data = this.getScrollerbehaviour(behaviours);

    if (!data.length) return false;
    return data.includes(id);
  }

  isEditing() {
    return !this.props.editRegionsMode;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    // Additional form handling logic if necessary
  };
  render() {

    const {
      layoutWidth,
      layoutHeight,
      playlists,
      profile,
      regionBehaviour,
      regionSound,
      getPlayListItemFromIds,
      behaviours,
    } = this.props;
    const { regions, count } = this.state;
    const ticker = this.getTicker();
    console.log("regions data", regions)

    // media playlist options
    var default_mediaPlaylist = {label:"-- Choose -- ", value:''}
    var mediaPlaylist_Options = [{label:"-- Choose -- ", value:''}]

    return (
      <div
        className={classNames(
          "layout-editor flex-container flex-direction-column",
          {
            editable: this.props.editRegionsMode,
            invalid: !this.state.layoutIsValid,
            valid: this.state.layoutIsValid,
          }
        )}
      >
        <ReactGridLayout
          className="layout flex-container flex-direction-row"
          key={`layout-${layoutHeight}x${layoutWidth}`} /* Update component after change layout size */
          onLayoutChange={this.onLayoutChange.bind(this)}
          cols={this.props.cols}
          maxRows={this.props.rows}
          // autoSize={false}
          preventCollision
          margin={[0, 0]}
          // compactType="horizontal"
          compactType={null}
          rowHeight={layoutHeight / this.props.rows}
          style={{ height: layoutHeight, width: layoutWidth }}
          draggableHandle=".drag"
          isDraggable={this.props.editRegionsMode}
          isResizable={this.props.editRegionsMode}
          width={layoutWidth}
        >
          {regions.map((region, index) => {
            // mediaPlaylist_Options = [];

            // playlists.length && profile != undefined?  
            // playlists.map((option) => {
            //     let isVideoList = this.isVideoList(option.items);
        
            //     const playlist = playlists.find(
            //       (e) => e.id === region.playlist
            //     );  
            //     if (
            //       count < profile.max_video_regions || !isVideoList || (playlist && this.isVideoList(playlist.items))
            //     ) {
            //       console.log({ label: option.name, value: option.id })
            //       if (!mediaPlaylist_Options.some((playlist) => playlist.label === option.name)) {
            //         mediaPlaylist_Options.push({ label: option.name, value: option.id });
            //       }
            //       if (region.playlist == option.id ) {
            //         default_mediaPlaylist = { label: option.name, value: option.id }
            //       }
            //     };
                
            //   })
            // : mediaPlaylist_Options = [{label:'add playlists to get options', value:''}]

            // console.log(mediaPlaylist_Options)

            mediaPlaylist_Options = playlists.length && profile != undefined ?
              playlists
                .filter((option) => {
                  let isVideoList = this.isVideoList(option.items);

                  const playlist = playlists.find((e) => e.id === region.playlist);
                  
                  return (
                    count < profile.max_video_regions ||
                    !isVideoList ||
                    (playlist && this.isVideoList(playlist.items))
                  );
                })
                .map((option) => {
                  console.log({ label: option.name, value: option.id });
                  return { label: option.name, value: option.id };
                })
              : [{ label: 'add playlists to get options', value: '' }];

            // Set default_mediaPlaylist based on the region's playlist
            default_mediaPlaylist = mediaPlaylist_Options.find(
              (playlist) => playlist.value === region.playlist
            ) || { label: '-- Choose --', value: '' };


            return (
              <div
                className={`${this.isEditing() ? "region-edit" : ""}`}
                key={region.id}
                data-grid={region.data_grid}
              >
                <div className="button drag">Region: {index + 1}</div>

                {/* <small>{JSON.stringify(this.getRegionDataGrid(region.id))}</small> */}
                {this.props.editRegionsMode && region.data_grid && (
                  <span className="text">
                    <small>
                      {region.data_grid.h}x{region.data_grid.w}
                    </small>
                  </span>
                )}

                {!this.props.editRegionsMode && (
                  <div className="region-edit-fields">
                    {!this.props.editRegionsMode && (
                      <div>
                        <label>Select Playlist</label>
                        <SelectSearch 
                          placeHolder={default_mediaPlaylist || "Select a playlist"}  
                          options={mediaPlaylist_Options} 
                          style={{width:`9rem`, backgroundColor:'white', color:'black'}}
                          onSelect={
                            (options)=>{ this.onAssignPlaylist(region.id, options.value) }
                          }
                          name={'Select Playlist'}
                          id={'SelectPlaylist'}
                          multiple={false}
                        />
                      </div>
                    )}
                    {regionSound && !this.props.editRegionsMode && (
                      <div>
                        <label>Audio Settings</label>
                        <select
                          name="behaviour"
                          id="behaviour"
                          title="Select Behaviour"
                          value={region.sound || "unmute"}
                          onChange={(e) =>
                            this.onAddField("sound", region.id, e.target.value)
                          }
                        >
                          <option value={"mute"}>Mute</option>
                          <option value={"unmute"}>Unmute</option>
                          <option value={"custom"}>Custom</option>
                        </select>
                      </div>
                    )}
                       <form onSubmit={this.handleSubmit}>
                    {regionSound &&
                      !this.props.editRegionsMode &&
                      region.sound &&
                      region.sound === "custom" && (
                        <div>
                          <label>Audio</label>
                          <input
                            type="file"
                            onChange={(e) =>
                              this.onAddFile(
                                "audio",
                                region.id,
                                e.target.files[0]
                              )
                            }
                            // value={region.audio || null}
                            id="avatar"
                            name="avatar"
                            accept="audio/mp3"
                          />
                          <span
                            onChange={(e) =>
                              this.onAddFile("audio", region.id, null)
                            }
                            style={{
                              marginLeft: "5px",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            Reset
                          </span>
                        </div>
                      )}
                      </form>
                      
                    {regionBehaviour && (
                      <>
                        {!this.props.editRegionsMode && (
                          <div>
                            <label>Region Behaviour</label>
                            <select
                              name="behaviour"
                              id="behaviour"
                              title="Select Behaviour"
                              value={
                                region.behaviour ||
                                this.getStandardbehaviour(behaviours)
                              }
                              onChange={(e) =>
                                this.onAddBehaviour(region.id, e.target.value)
                              }
                            >
                              {behaviours.map((option) => {
                                return (
                                  <option key={option.id} value={option.id}>
                                    {option.display_name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        )}
                        
                        {region && region.behaviour == this.getMirrorPublisher(behaviours) &&
                           <div >
                           <label>Regional Thumbnail</label>
                           {region.regional_thumbnail && 
                            <a href={region.regional_thumbnail} target="_blank" rel="noopener noreferrer">
                             <small>regional thubmail</small>
                          </a>}
                          <input
                            type="file"
                            onChange={(e) =>
                              this.onAddFile(
                                "region_thumbnail",
                                region.id,
                                e.target.files[0]
                              )
                            } 
                            // value={region.audio || null}
                            id="avatar"
                            name="avatar"
                            accept="image/*"
                          />
                          </div>
                        }

                        {region && region.behaviour == this.getDirectoryPublisher(behaviours) &&
                         <div >
                           <label>Folder Icon</label>
                         {region.folder_icon &&  <a href={region.folder_icon} target="_blank" rel="noopener noreferrer">
                             <small>folder icon</small>
                          </a>}

                          <input
                            type="file"
                            onChange={(e) =>
                              this.onAddFile(
                                "folder_icon",
                                region.id,
                                e.target.files[0]
                              )
                            } 
                            // value={region.audio || null}
                            id="avatar"
                            name="avatar"
                            accept="image/*"
                          />
                          </div>

                          
                        }
                         {region && region.behaviour == this.getDirectoryPublisher(behaviours) &&
                            <div >
                              
                            <label>Regional Thumbnail</label>
                            {region.regional_thumbnail &&  <a href={region.regional_thumbnail} target="_blank" rel="noopener noreferrer">
                             <small>regional thubmail</small>
                          </a>}

                           <input
                             type="file"
                             onChange={(e) =>
                               this.onAddFile(
                                 "region_thumbnail",
                                 region.id,
                                 e.target.files[0]
                               )
                             } 
                             // value={region.audio || null}
                             id="avatar"
                             name="avatar"
                             accept="image/*"
                           />
                           </div>

                          
                        }
                        {!this.props.editRegionsMode &&
                          this.isScroller(region.behaviour, behaviours) && (
                            <>
                              <div>
                                <label>Maximum No of items in View</label>

                                <input
                                id="item-id"
                                name="item-id"
                                type="text"
                                className="input-size"
                                defaultValue={region.item_no || 2}
                                placeholder="item number"
                                title="Item no"
                                onBlur={(e) => this.onAddField("item_no", region.id, parseInt(e.target.value))}
                              />

                               
                                {/* <input value={region.item_no || 2} type="text" min="2" max="100" onChange={(e) => this.onAddField("item_no", region.id, parseInt(e.target.value))} /> */}
                              </div>

                              <div>
                                <label>Scrolling Direction</label>
                                <select
                                  name="behaviour"
                                  id="behaviour"
                                  title="Select Direction"
                                  value={region.direction || ""}
                                  onChange={(e) =>
                                    this.onAddField(
                                      "direction",
                                      region.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="horizontal">Horizontal</option>
                                  <option value="vertical">Vertical</option>
                                </select>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </div>
                )}

                {this.props.editRegionsMode && (
                  <span
                    className="remove"
                    onClick={this.onRemoveRegion.bind(this, region.id)}
                  >
                    ×
                  </span>
                )}
              </div>
            );
          })}
        </ReactGridLayout>
        {ticker && (
          <TickerPlayer
            key={`ticker-${layoutHeight}x${layoutWidth}`} /* Update component after change layout size */
            className="flex-container flex-direction-row"
            disableOverlay
            background={ticker.background}
            colour={ticker.colour}
            outline={ticker.outline}
            fontFamily={ticker.font_family}
            fontSize={ticker.font_size}
            speed={ticker.speed}
            isURL={ticker.is_url}
            text={ticker.text}
            index={this.state.tickerIndex}
            onTickerEnd={this.nextTicker}
          />
        )}
      </div>
    );
  }
}

export default ChannelLayoutEditor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ChannelLayoutEditor/index.js